import React from 'react'
import AloModal from '../AloModal'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import PhotoSelector from './PhotoSelector'
import './PhotoUploader.scss'
import axiosInstance from 'api/axios.config'
import classNames from 'classnames'
import FileUploadProgress from 'react-fileupload-progress'

import ReactCrop from 'react-image-crop'
import '../../../../node_modules/react-image-crop/lib/ReactCrop.scss'

import { Line } from 'rc-progress'
import AloButton from '../AloButton'

class PhotoUploader extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      display: props.currentImageUrl ? 'SELECT' : 'EDIT',
      src: '',
      crop: {
        aspect: 1,
        width: 80,
        x: 0,
        y: 0
      },
      uploading: false,
      percentageUploaded: 0,
      croppedUrl: '', // this is the local url for the cropped file
      remoteCoverPhotoUrl: '' // This is the url to the temporary bucket on aws,
    }
    this.fileReader = new window.FileReader()

    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleOnImageLoaded = this.handleOnImageLoaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleOnComplete = this.handleOnComplete.bind(this)
    this.getCroppedImage = this.getCroppedImage.bind(this)
    this.changeDisplay = this.changeDisplay.bind(this)
    this.uploadImage = this.uploadImage.bind(this)
    this.removePhoto = this.removePhoto.bind(this)
  }

  changeDisplay (display) {
    this.setState({ display })
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.file || prevProps.file.name !== this.props.file.name) {
      this.fileReader.addEventListener(
        'load',
        () => {
          this.setState({ src: this.fileReader.result })
        },
        false
      )

      if (this.props.file) {
        this.fileReader.readAsDataURL(this.props.file)
      }
    }
  }

  handleOnImageLoaded (image) {
    this.imageRef = image
  }

  handleOnChange (crop) {
    this.setState({ crop })
  }

  handleOnComplete (crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      this.getCroppedImage(this.imageRef, pixelCrop, 'croppedFile.jpeg').then(
        croppedBlob => {
          this.croppedFileUrl = window.URL.createObjectURL(croppedBlob)
          this.setState({ croppedUrl: this.croppedFileUrl, croppedBlob })
        }
      )
    }
  }

  removePhoto() {
    if (this.state.remoteCoverPhotoUrl) {
      this.setState({
        remoteCoverPhotoUrl: ''
      })
      this.props.onHide()
    } else {
      //making the first letter of photoType capital in order to pass it to snakeCase formatting later
      const remoteKey = `remove${this.props?.photoType?.charAt(0)?.toUpperCase()+this.props.photoType?.slice(1)}Photo`
      this.props.onDelete(remoteKey)
    }
  }

  getCroppedImage (image, pixelCrop, fileName) {
    const tempCanvas = document.createElement('canvas')
    tempCanvas.width = pixelCrop.width
    tempCanvas.height = pixelCrop.height

    const context = tempCanvas.getContext('2d')

    context.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    )

    return new Promise(resolve => {
      tempCanvas.toBlob(blob => {
        if (!blob) {
          console.log('Image could not be converted')
        }
        blob.name = fileName
        window.URL.revokeObjectURL(this.croppedFileUrl)
        resolve(blob)
      }, 'image/jpeg')
    })
  }

  uploadImage () {
    const fd = new window.FormData()
    fd.append('image', this.state.croppedBlob)

    axiosInstance.post('/upload/image', fd).then(res => {
      const tempURL = res.data.imageUrl
      this.props.onHide()
      this.props.onUploaded(tempURL)
    })
  }

  getDisplayedView () {
    switch (this.state.display) {
      case 'EDIT':
        if (this.state.src) {
          return (
            <React.Fragment>
              <Modal.Body>
                <div className='PhotoUploader__cropper'>
                  <ReactCrop
                    src={this.state.src}
                    locked
                    crop={this.state.crop}
                    onChange={this.handleOnChange}
                    onComplete={this.handleOnComplete}
                    onImageLoaded={this.handleOnImageLoaded}
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className='grey'
                  onClick={() => {
                    this.props.onHide()
                  }}
                >
                  Cancel
                </button>
                <AloButton
                  className='btn alo-button'
                  onClick={() => {
                    this.changeDisplay('CONFIRM')
                  }}
                >
                  Preview Photo
                </AloButton>
              </Modal.Footer>
            </React.Fragment>
          )
        }
        break
      case 'CONFIRM':
        return (
          <FileUploadProgress
            url={`${window.location.origin}/api/v2/upload/image`}
            method='POST'
            formGetter={() => {
              const fd = new window.FormData()
              fd.append('image', this.state.croppedBlob)
              return fd
            }}
            onLoad={(_, request) => {
              this.setState({ uploading: false })
              const response = JSON.parse(request.response)
              const tempUrl = response.image_url
              this.props.onHide()
              this.props.onUploaded(tempUrl)
            }}
            progressRenderer={progress => {
              if (this.state.uploading) {
                return (
                  <Modal.Body>
                    <div className='PhotoUploader__uploadContainer'>
                      <div className='PhotoUploader__uploadProgress'>
                        <span>Uploading</span>
                        <Line
                          percent={progress}
                          strokeWidth='2'
                          strokeColor='#000000'
                          trailWidth='2'
                          trailColor='#D3D3D3'
                          strokeLinecap='square'
                          style={{ border: '1px solid #F5F5F5' }}
                        />
                      </div>
                    </div>
                  </Modal.Body>
                )
              }
            }}
            formRenderer={onSubmit => {
              if (!this.state.uploading) {
                return (
                  <form>
                    <Modal.Body>
                      <img src={this.state.croppedUrl} />
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        className='grey'
                        onClick={() => {
                          this.changeDisplay('EDIT')
                        }}
                      >
                        Go back
                      </button>
                      <button
                        className='btn alo-button'
                        onClick={e => {
                          this.setState({ uploading: true })
                          onSubmit(e)
                        }}
                      >
                        Looks good
                      </button>
                    </Modal.Footer>
                  </form>
                )
              }
            }}
          />
        )
      case 'PROCESSING':
        return (
          <Modal.Body>
            <p>Processing Photo</p>
          </Modal.Body>
        )
      case 'SELECT':
        return (
          <React.Fragment>
            <Modal.Body>
              <div className='photo hidden-xs'>
                <img
                  src={
                    this.state.remoteCoverPhotoUrl || this.props.currentImageUrl
                  }
                />
              </div>
              <hr className='hidden-xs' />
              <PhotoSelector
                modifiying
                photoType={this.props.photoType}
                onUploaded={updatedImageUrl => {
                  this.setState(
                    {
                      remoteCoverPhotoUrl: updatedImageUrl
                    },
                    () => {
                      this.props.onHide()
                      this.props.onUploaded(updatedImageUrl)
                    }
                  )
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <button className='grey' onClick={this.removePhoto}>
                {this.props.removingImage ? 'Removing...' : 'Remove photo'}
              </button>
              <AloButton className='btn alo-button' onClick={this.props.onHide}>
                Close
              </AloButton>
            </Modal.Footer>
          </React.Fragment>
        )
    }
  }

  render () {
    let className = classNames('PhotoUploader', {
      'PhotoUploader--main': this.state.display === 'SELECT',
      'PhotoUploader--confirm': this.state.display === 'CONFIRM',
      'PhotoUploader--editor': this.state.display === 'EDIT',
      'PhotoUploader--processing': this.state.display === 'PROCESSING',
      'PhotoUploader--uploading': this.state.uploading
    })

    return (
      <AloModal
        onHide={this.props.onHide}
        show={this.props.show}
        onClick={e => {
          e.stopPropagation()
        }}
        className={className}
      >
        <Modal.Header>
          {this.props.modifiying ? 'Update' : 'Upload'} {this.props.photoType}{' '}
          {this.state.display === 'EDIT' ? ': Move & Scale' : null}
          {this.state.display === 'CONFIRM'
            ? ': This is how it will look '
            : null}
          photo
        </Modal.Header>
        {this.getDisplayedView()}
      </AloModal>
    )
  }
}

PhotoUploader.propTypes = {
  show: PropTypes.bool,
  file: PropTypes.object,
  onHide: PropTypes.func,
  currentImageUrl: PropTypes.string,
  onUploaded: PropTypes.func,
  photoType: PropTypes.string,
  modifiying: PropTypes.bool,
  onDelete: PropTypes.func,
  removingImage: PropTypes.bool
}

export default PhotoUploader
